import { graphql } from '../graphql';

export const startRainfallAnalysis = graphql(`
  mutation StartRainfallAnalysis($input: StartRainfallAnalysisInput!) {
    startRainfallAnalysis(input: $input)
  }
`);
